module.exports = "/images/ae.svg?dc86fdcfeb9510fdb06431d86fea11fd";